export default __webpack_public_path__ + "static/media/brokerage-trucking-not-selected_skyblue.f4549ccd.svg";